import React from "react";
import { Helmet } from "react-helmet";
import { EditOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useGetUserProfileApi } from "./useUserApi";
import { getItem } from "utils/local-storage";
import { useTranslation } from "react-i18next";
import GlobalStore from "stores/globalStore";
import FreePremium from "components/user/dashboard/FreePremium";
import QR from "../../../assets/img/open-app-qr.jpg";
import "./profileUser.css";
import { Row } from "antd";
import Loading from "components/Loading/Loading";

const ProfileUser: React.FC = () => {
  const { profileObject, isLoading } = useGetUserProfileApi();
  const { t } = useTranslation();
  const { entitlements } = GlobalStore.useContainer();
  const isProLifetime = entitlements?.tier?.code !== "free" && !entitlements?.tier?.expire_at;
  const isConversationBundle = entitlements?.transactions ? entitlements.transactions.filter((item) => item.catalog === "ai_role_play_sa") : [];
  const isNova = profileObject?.data?.nova_mode;

  const formatDateOfBirth = (inputDate: string) => {
    if (inputDate) {
      var date = new Date(inputDate);
      if (!isNaN(date.getTime())) {
        return date.getDate() + "/" + +(date.getMonth() + 1) + "/" + date.getFullYear();
      }
    } else {
      return "--";
    }
  };

  return (
    <div className="dashboard-package-container">
      <Helmet>
        <title>User Account - ELSA Speak</title>
        <meta name="description" content="ELSA Speak App user account login for web PC. Redeem promo code ELSA Speak Pro, ELSA Oxford Business Result, ELSA for Students, ELSA Speak free." />
      </Helmet>
      <h2>{t("homepage.page_title")}</h2>
      {isLoading ? (
        <Row justify="center">
          <Loading color="#ccc" />
        </Row>
      ) : (
        <article className="dashboard-profile-container">
          <section className="dashboard-profile-body">
            <h3 className="dashboard-profile-title">
              {t("profile.account_info")}
              <Link to={`/${t("slug.update_profile")}`} className="dashboard-profile-icon">
                <EditOutlined />
              </Link>
            </h3>
            <table className="table">
              <colgroup className="table-column-group">
                <col className="" />
                <col className="" />
              </colgroup>
              <tbody className="table-body">
                <tr className="table-row">
                  <td className="table-column row-label">{t("profile.user_name")}</td>
                  <td className="table-column row-value">{profileObject?.data?.username}</td>
                </tr>
                <tr className="table-row">
                  <td className="table-column row-label">{t("profile.phone_number")}</td>
                  <td className="table-column row-value">{profileObject?.data?.phone}</td>
                </tr>
                <tr className="table-row">
                  <td className="table-column row-label">{t("profile.email")}</td>
                  <td className="table-column row-value">{getItem("email-login")}</td>
                </tr>
                <tr className="table-row">
                  <td className="table-column row-label">{t("profile.date_of_birth")}</td>
                  <td className="table-column row-value">{formatDateOfBirth(profileObject?.data?.date_of_birth)}</td>
                </tr>
                <tr className="table-row">
                  <td className="table-column row-label">{t("profile.address")}</td>
                  <td className="table-column row-value">{profileObject?.data?.address || "--"}</td>
                </tr>
              </tbody>
            </table>
          </section>

          <section className="dashboard-package">
            {entitlements?.tier?.code !== "free" && (
              <div className="card-package">
                <div className="card-package__panel">
                  <div className="card-package-header">
                    {entitlements?.tier && (
                      <div className="card-package-header-name">
                        <span className="card-package-header-title">Paket saat ini: ELSA {entitlements?.tier?.code[0].toUpperCase() + entitlements?.tier?.code.slice(1)}</span>
                        <div className="features">
                          {isProLifetime ? (
                            <>
                              {t("packages.using_unlimited")}
                              {isConversationBundle.length ? <p>{t("and")} conversation bundle: ELSA AI & Speech Analyzer</p> : ""}
                            </>
                          ) : (
                            <p>
                              Tanggal kedaluwarsa:
                              <strong>{" " + new Date(entitlements?.tier.expire_at * 1000).toLocaleDateString("it-IT")}</strong>
                            </p>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            {entitlements?.tier?.code !== "premium" || !isNova ? (
              <FreePremium isNova={isNova} tier={entitlements?.tier?.code} />
            ) : (
              <div className="qr-code">
                <p>สแกนรหัส QR เพื่อเปิดแอปและเริ่มฝึกซ้อมได้ทันที!</p>
                <img src={QR} alt="" width={240} />
              </div>
            )}
          </section>
        </article>
      )}
    </div>
  );
};

export default ProfileUser;
